import script from "./SignalRNotifier.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignalRNotifier.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__